/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListRefund from '../views/refund-internal/ListRefund.vue';

import { setBreadcrumb } from './index';

const refundInternalRoute = {
  path: '/refund-internal',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Refund Internal',
        appBarTitle: 'Refund Internal',
        breadcrumbs: () => [
          setBreadcrumb('Refund Internal', '/refund-internal', true),
          setBreadcrumb('List Refund Internal', '/refund-internal'),
        ],
      },
      component: ListRefund,
      name: 'ListRefund',
    },
  ],
  meta: {
    title: 'BNI QRIS - Refund Internal',
    appBarTitle: 'Refund Internal',
  },
  component: Parent,
};

export default refundInternalRoute;
